import React, { useState } from "react";
import { Card, Col, Container, Row } from "react-bootstrap";
import defaultPhoto from "../../assets/images/imagePlaceholder.png";
import { FaLocationDot } from "react-icons/fa6";
import OffersList from "../OfferList/Offers";
import { FaHeart, FaRegHeart } from "react-icons/fa";
import { axiosFunction } from "../../axiosFunction";
import { useSelector } from "react-redux";
import { smaartCardUrl } from "../../constant";
import { toastMessage } from "../../utils/toastUtils";
import { useNavigate } from "react-router-dom";
import usePartnerList from "../../Hooks/usePartnerList";

const PartnerListCard = ({
  partners,
  handleCardClick,
  offers = true,
  getFavouritePartners,
}) => {
  const { getPartnerList } = usePartnerList();

  const cityName = localStorage.getItem("partnerCity") || "";
  const offerId = localStorage.getItem("offerId") || 0;
  const userId = localStorage.getItem("userId") || 0;

  const navigate = useNavigate();

  const userData = useSelector((state) => state.userData);

  const toggleFavorite = async (partner, e) => {
    e.stopPropagation();

    if (!localStorage.getItem("userId")) {
      navigate("/login");
      return;
    }

    try {
      let response;
      if (partner.isFavourite === 1) {
        // Call delete API if already favorite
        response = await axiosFunction(
          `${smaartCardUrl}/api/v1/dfordr/user/deleteFavouritePartner?userId=${userData.patientId}&partnerId=${partner.partnerId}`,
          "DELETE",
          ""
        );
      } else {
        // Call add API if not favorite
        response = await axiosFunction(
          `${smaartCardUrl}/api/v1/dfordr/user/addFavouritePartner?userId=${userData.patientId}&partnerId=${partner.partnerId}`,
          "POST",
          ""
        );
      }

      if (response?.data?.status) {
        if (getFavouritePartners) {
          getFavouritePartners();
        } else {
          getPartnerList(0, 1000, cityName, 0, offerId, userId);
        }
        toastMessage(response?.data?.message, "success");
      } else {
        toastMessage(response?.data?.message || "Operation failed", "error");
      }
    } catch (error) {
      console.error("Error toggling favorite:", error);
      toastMessage("An error occurred", "error");
    }
  };

  return (
    <Container>
      {offers && <OffersList />}
      <Row>
        {partners?.length > 0 ? (
          partners?.map((partnerObj) => {
            return (
              <Col md={6} className="mt-2">
                <Card
                  onClick={() => handleCardClick(partnerObj)}
                  className="categoryMainCard"
                >
                  <Row>
                    <Col md={4} xs={4} className="customCenter">
                      <div className="mainImgBox">
                        <img
                          style={{ maxHeight: "100%", maxWidth: "100%" }}
                          className="img-fluid"
                          src={partnerObj?.partnerPhoto || defaultPhoto}
                          alt="google_store_img"
                        />

                        <div
                          className="favorite-icon"
                          onClick={(e) => toggleFavorite(partnerObj, e)}
                          style={{
                            position: "absolute",
                            top: "10px",
                            left: "20px",
                            cursor: "pointer",
                            zIndex: 1,
                            transition: "all 0.3s ease",
                          }}
                        >
                          {partnerObj?.isFavourite === 1 ? (
                            <FaHeart color="red" size={20} />
                          ) : (
                            <FaRegHeart color="black" size={20} />
                          )}
                        </div>
                      </div>
                    </Col>
                    <Col md={8} xs={8}>
                      <Card.Body className="categoryCardContent">
                        <Card.Title className="categoryTitle">
                          {partnerObj?.partnerName}
                        </Card.Title>
                        <Card.Subtitle className="mb-2 categorySubTitle">
                          <div className="mb-1">{partnerObj?.category}</div>
                          <strong style={{ margin: "0 5px 0 0" }}>
                            Specialization:
                          </strong>
                          {partnerObj?.specialization?.length > 0
                            ? partnerObj?.specialization?.map((spc) => (
                                <span className="sp-name">{spc}</span>
                              ))
                            : "--"}
                        </Card.Subtitle>
                        <Card.Text className="categoryAddBox d-lg-block d-none">
                          <FaLocationDot className="locationIcon" />
                          <span className="categoryAdd">
                            {partnerObj?.partnerAddress}
                          </span>
                        </Card.Text>
                      </Card.Body>
                    </Col>
                    <Col xs={12} className="d-lg-none d-block">
                      <div className="categoryAddBoxMob">
                        <FaLocationDot className="locationIcon" />
                        <span className="categoryAdd">
                          {partnerObj?.partnerAddress}
                        </span>
                      </div>
                    </Col>
                  </Row>
                </Card>
              </Col>
            );
          })
        ) : (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              backgroundColor: "#f0f7ff",
              borderRadius: "5px",
              lineHeight: "20px",
              padding: "20px",
              color: "#024089",
              marginTop: "20px",
            }}
          >
            No Partner Found
          </div>
        )}
      </Row>
    </Container>
  );
};

export default PartnerListCard;
